export default "__VITE_ASSET__2RLb$HI$__"